import React from 'react'

function IpdDetails() {
  return (
    <div>IpdDetails</div>
  )
}

export default IpdDetails